var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",staticStyle:{"padding":"10px","text-align":"center","position":"fixed","bottom":"0","left":"0","right":"0","background":"#fff","margin-left":"55px","margin-top":"100px"}},[_c('div',[_vm._v("Copyright © 2020 livingtrip.uyl.cn. All Rights Reserved. 依蓝云（北京）科技有限公司 版权所有 ISP证：鲁B1-20190022")]),_c('div',[_vm._v("系统版本：v3.1.11")])])
}]

export { render, staticRenderFns }